<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>Invoice Report</span>
    </div>
    <el-row :gutter="10" class="search-area">
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-date-picker v-model="year" type="year" placeholder="Select year" @change="getInvoiceList(year)" value-format="yyyy"></el-date-picker>
      </el-col>
    </el-row>
    <el-row class="invoice-report">
      <el-col>
        <el-table v-loading="loading" :data="tableData" border>
          <el-table-column prop="month" fixed label="Month" header-align="center" align="center"></el-table-column>
          <el-table-column prop="totalgbp" label="GBP" header-align="center" align="center">
            <template slot-scope="scope">{{ formatNumber(scope.row.totalgbp) }}</template>
          </el-table-column>
          <el-table-column prop="totaleur" label="EUR" header-align="center" align="center">
            <template slot-scope="scope">{{ formatNumber(scope.row.totaleur) }}</template>
          </el-table-column>
          <el-table-column prop="downloaded" label="Download" header-align="center" align="center">
            <template slot-scope="scope">

              <el-link
                class="el-button el-button--success el-button--mini"
                icon="el-icon-download"
                :href="downloadInvoice(scope.row.uid)"
                target="_blank"
              >Download</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="downloaddate"
            label="Download Date"
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import invoice from "@/api/invoice";
import utility from "@/components/utility";
export default {
  data() {
    return {
      baseurl: process.env.VUE_APP_SERVER_BASE_API || "",
      tableData: [],
      loading: true,
      year: utility.currentYear()
    };
  },
  methods: {
    getInvoiceList(year) {
      this.loading = true
      let data = {
        year: year
      };

      invoice.getInvoiceLists(data).then(res => {
        if (res && res["result"]) {
          this.tableData = res["data"];
        }else{
          this.tableData = [];
        }
        this.loading = false;
      });
    },
    downloadInvoice(uid) {
      let data = {
        uid: uid
      };
      return (
        this.baseurl +
        "/api/invoices/download" +
        utility.objectToQuerystring(data)
      );
    },
    formatNumber(num) {
      return utility.currencyFormat(num);
    }
  },
  created() {
    this.getInvoiceList(this.year);
  }
};
</script>

<style lang="scss">
.search-area{
  margin-bottom: 16px;
}
.invoice-report {
  margin-bottom: 16px;

  .el-button {
    margin-left: 20px;
  }

  .el-link.el-link--default {
    color: #ffffff;
  }

  .sc-table{
     border: 1px solid #EBEEF5;
   }
   .el-table th.is-leaf{
     background-color: rgb(121, 136, 150);
     color: #ffffff;
   }
   .el-table th.is-leaf, .el-table td {
      border-bottom: 1px solid #EBEEF5;
      border-right: 1px solid #EBEEF5;
    }

}
</style>